import request from '@/http/request'
import {
    getStudentExamList,
    getOtsStudentExam,
    ipCheck
} from '@/http/api'

export const getExamList = (data) => {
    return request({
        url: getStudentExamList,
        data
    })
}

export const arrangementInfo = (data) => {
    return request({
        url: ipCheck,
        data
    })
}

export const goOtsStartExam = (data) => {
    return request({
        url: getOtsStudentExam,
        data
    })
}